// userControlId is only used by the FE (drag & drop keys); the save-template,
// update-template (AiUserControl), save-pre-consult-template and
// update-pre-consult-template (PreConsultUserControl) APIs don't accept it, so drop
// it before sending.
//
// Completely empty sections (blank sectionTitle and no user control with a label,
// e.g. an "Add Section" left untouched) are also removed, since SectionTitle is
// required by the API. Partially filled sections are kept as-is: the builder
// shows inline errors for those instead of silently dropping the user's input.
const isBlank = (value) => !String(value ?? "").trim();

const isEmptySection = (section) =>
  isBlank(section?.sectionTitle) &&
  (section?.userControls || []).every((control) => isBlank(control?.label));

export const stripAiTemplateUserControlIds = (template) => ({
  ...template,
  templateSections: template?.templateSections
    ?.filter((section) => !isEmptySection(section))
    .map((section) => ({
      ...section,
      userControls: section?.userControls?.map(
        ({ userControlId, ...control }) => control,
      ),
    })),
});
